import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { Row, Col, Label, Input, FormFeedback } from 'reactstrap';

import CurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput.js"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaAsyncSeeker2 from "../../../components/ParadigmaAsyncSeeker_v2/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import { formatCurrency } from './../../functions/dateFunctions.js'

const parseMontoFloat = (x) => (parseFloat(((x.toString()).replace(/[.]/g, '')).replace(',', '.')));

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      nroFactura: '',
      solicitud_id: null,
      empresa_id: null,
      uvt_id: null,
      personalDistribucion_id: null,
      fechaDeFacturacion: moment(),
      fechaDeCobro: moment(),
      monto: '0,00',
      insumosDirectos: '0,00',
      observaciones: '',
      porcentajeUVT: 0,
      porcentajeFPLQ: 40,
      porcentajeEjecutores: 0,
      porcentajes: [],
      separaciones: [],

      postVariables: ['nroFactura', 'solicitud_id', 'empresa_id', 'personalDistribucion_id', 'fechaDeFacturacion', 'fechaDeCobro', 'monto', 'insumosDirectos', 'observaciones', 'porcentajeUVT', 'porcentajeFPLQ', 'porcentajeEjecutores', 'porcentajes',],
      errors: {},
    };
  }

  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    action: PropTypes.string.isRequired,
  }

  setData = (data) => {
    this.setState({
      ...data,
      fechaDeFacturacion: moment(data.fechaDeFacturacion),
      fechaDeCobro: moment(data.fechaDeCobro),
      monto: formatCurrency(data.monto),
      insumosDirectos: formatCurrency(data.insumosDirectos),
    })
  }

  getData = () => {
    const { postVariables } = this.state;
    const data = {};
    postVariables.forEach(key => {
      data[key] = this.state[key];
    })
    data.monto = parseMontoFloat(data.monto);
    data.insumosDirectos = parseMontoFloat(data.insumosDirectos);
    data.porcentajeEjecutores = parseMontoFloat(100 - data.porcentajeFPLQ - data.porcentajes.reduce((pv, cv) => pv + cv.porcentaje, 0));
    return data;
  }

  resetState = () => {
    this.setState({
      nroFactura: '',
      solicitud_id: null,
      empresa_id: null,
      uvt_id: null,
      personalDistribucion_id: null,
      fechaDeFacturacion: moment(),
      fechaDeCobro: moment(),
      monto: '0,00',
      insumosDirectos: '0,00',
      observaciones: '',
      porcentajeUVT: 0,
      porcentajeFPLQ: 40,
      porcentajeEjecutores: 0,
      porcentajes: [],
      separaciones: [],

      errors: {},
    })
  }

  onValidation = () => {
    const {
      nroFactura,
      solicitud_id,
      empresa_id,
      uvt_id,
      personalDistribucion_id,
      monto,
      insumosDirectos,
      porcentajeUVT,
      porcentajeFPLQ,
      porcentajeEjecutores,
      porcentajes,
    } = this.state;

    const { action } = this.props;

    let montoUVT = parseMontoFloat(monto) * (porcentajeUVT / 100);

    let errors = {};

    if (!!!nroFactura) {
      errors.nroFactura = 'Ingrese un nro. de factura';
    }
    if (!!!solicitud_id) {
      errors.solicitud_id = 'Seleccione un N° de presupuesto';
    }
    if (!!!empresa_id) {
      errors.empresa_id = 'Seleccione un cliente';
    }
    if (!!!uvt_id && action == "CREATE") {
      errors.uvt_id = 'Ingrese un valor valido';
    }
    if (!!!personalDistribucion_id) {
      errors.personalDistribucion_id = 'Selecione un lider técnico';
    }
    if ((parseMontoFloat(monto) - montoUVT - parseMontoFloat(insumosDirectos)) < 0) {
      errors.insumosDirectos = 'Ingrese un importe valido'
    }
    if (parseMontoFloat(monto) <= 0) {
      errors.monto = 'Ingrese un importe mayor a 0'
    }
    if (porcentajeFPLQ < 0 || porcentajeFPLQ > 100) {
      errors.porcentajeFPLQ = 'Ingrese un porcentaje valido';
    }
    if (porcentajeEjecutores < 0 || porcentajeEjecutores > 100) {
      errors.porcentajeEjecutores = 'Ingrese un porcentaje valido';
    }
    if (porcentajes.length > 0 && porcentajes.reduce((pv, cv) => pv + cv.porcentaje, (porcentajeFPLQ + porcentajeEjecutores)) > 100) {
      errors.porcentajeFPLQ = 'Ingrese un porcentaje valido';
    }

    this.setState({ errors });
    return Object.keys(errors).length == 0;
  }

  updatePorcentajesArray = (newLength) => {
    const template = { label: '', porcentaje: 0 };
    const porcentajes = [...this.state.porcentajes];
    while (newLength > porcentajes.length) {
      porcentajes.push({ ...template });
    }
    while (newLength < porcentajes.length) {
      porcentajes.pop();
    }
    this.setState({ porcentajes })
  }

  getParadigmaModalProps = () => {
    const { action, onClose } = this.props;
    if (action == "CREATE") {
      return {
        action,
        postUrl: api.imputaciones.imputaciones.create,
        buttonTitle: "Nueva",
        onPreSubmit: () => this.getData(),
        onClose: () => this.resetState() & (onClose && onClose()),
        onValidation: () => this.onValidation(),
        onSubmit: () => this.props.onSubmit(),
        disabled: false,
        successMessage: "La Imputacion ha sido creada con éxito.",
        title: "Nueva Imputacion",
        buttonIcon: "fa fa-plus fa-lg",
        saveButton: true,
        closeButton: true,
      }
    } else if (action == "EDIT") {
      return {
        action,
        postUrl: api.imputaciones.imputaciones.edit,
        getUrl: api.imputaciones.imputaciones.edit,
        buttonTitle: "Editar",
        id: this.props.id,
        onGotData: (data) => this.setData(data),
        onPreSubmit: () => this.getData(),
        onClose: () => this.resetState() & (onClose && onClose()),
        onValidation: () => this.onValidation(),
        onSubmit: () => this.props.onSubmit(),
        disabled: this.state.separaciones.length > 1,
        successMessage: "La imputacion ha sido editada con éxito.",
        title: "Editar Imputación",
        buttonIcon: "fa fa-pencil fa-lg",
        saveButton: true,
        closeButton: true,
      }
    } else if (action == "DETAIL") {
      return {
        action,
        getUrl: api.imputaciones.imputaciones.detail,
        buttonTitle: "Ver",
        id: this.props.id,
        onGotData: (data) => this.setData(data),
        onClose: () => this.resetState() & (onClose && onClose()),
        onValidation: () => this.onValidation(),
        onSubmit: () => this.props.onSubmit(),
        disabled: true,
        successMessage: "La imputacion ha sido editada con éxito.",
        title: "Imputación",
        buttonIcon: "fa fa-search fa-lg",
        saveButton: false,
        closeButton: true,
      }
    } else if (action == "DELETE") {
      return {
        action,
        postUrl: api.imputaciones.imputaciones.delete,
        getUrl: api.imputaciones.imputaciones.detail,
        buttonTitle: "Eliminar",
        id: this.props.id,
        onGotData: (data) => this.setData(data),
        onClose: () => this.resetState() & (onClose && onClose()),
        onValidation: () => this.onValidation(),
        onSubmit: () => this.props.onSubmit(),
        disabled: true,
        successMessage: "La imputacion ha sido eliminada con éxito.",
        title: "Eliminar Imputación",
        saveButtonLabel: "Eliminar",
        buttonIcon: "fa fa-trash fa-lg",
        danger: true,
        buttonClass: "btn-danger",
        saveButton: true,
        closeButton: true,
      }
    }
  }

  onFechaDeCobroChange = (fechaDeCobro) =>{
    this.setState({ fechaDeCobro: fechaDeCobro })
  }

  onMontoChange = (data) => {
    this.setState({ monto: data })
  }

  render() {
    const {
      nroFactura,
      solicitud_id,
      empresa_id,
      uvt_id,
      fechaDeFacturacion,
      fechaDeCobro,
      monto,
      insumosDirectos,
      porcentajeUVT,
      porcentajeFPLQ,
      porcentajeEjecutores,
      porcentajes,
      observaciones,
      errors,
    } = this.state;

    const paradigmaModalProps = this.getParadigmaModalProps();
    let montoUVT = parseMontoFloat(monto) * (porcentajeUVT / 100);

    return (
      <ParadigmaModal {...paradigmaModalProps} className={"ui-modal-dialog ui-modal-lg"}>
        <div className="ui-form">

        <ParadigmaLabeledInput
          autoFocus={paradigmaModalProps.action == "CREATE"}
          labelClassName="text-left"
          type="number"
          label="Nro. Factura"
          fieldName="nroFactura"
          disabled={paradigmaModalProps.disabled}
          labelColumns={4}
          fieldColumns={4}
          value={nroFactura}
          onChange={(e) => this.setState({ nroFactura: e.target.value ? e.target.value : "" })}
        />
        <Row>
          <Col className="col-12 col-sm-4" />
          <Col className="col-12 col-sm-4">
            <FormFeedback className={(errors.nroFactura != undefined ? "d-block" : "")}> {errors.nroFactura} </FormFeedback>
          </Col>
        </Row>

        <ParadigmaLabeledInput
          label="N° Presupuesto"
          labelColumns={4}
          fieldColumns={8}
          inputComponent={
            <Fragment>
              <ParadigmaAsyncSeeker
                  url={api.proyectos.solicitudes.selectcodigo}
                  value={solicitud_id}
                  fieldName="solicitud"
                  disabled={paradigmaModalProps.disabled}
                  nombreField="cod"
                  onChange={(e) => this.setState({
                      solicitud_id: e && e.pk ? e.pk : null,
                      uvt_id: e && e.uvt_id ? e.uvt_id : null,
                      porcentajeUVT: e && e.porcentajeUVT ? e.porcentajeUVT : 0,
                      personalDistribucion_id: e && e.ltp_personal_id ? e.ltp_personal_id : null,
                      empresa_id: e && e.empresa_id ? e.empresa_id : null,
                  })}
              />
              <FormFeedback className={(errors.solicitud_id != undefined ? "d-block" : "")}>{errors.solicitud_id}</FormFeedback>
            </Fragment>
          }
        />

        <ParadigmaLabeledInput
          label={"Título"}
          labelColumns={4}
          fieldColumns={8}
          inputComponent={
            <ParadigmaAsyncSeeker
              url={api.proyectos.solicitudes.selectcodigo}
              value={solicitud_id}
              disabled={true}
              nombreField={"nombre"}
            />
          }
          />
          {
          paradigmaModalProps.action == "CREATE" &&
          <ParadigmaLabeledInput
            label="Unidad de Vinculación"
            labelColumns={4}
            fieldColumns={8}
            inputComponent={
              <ParadigmaAsyncSeeker
                disabled
                fieldName="uvt_id"
                url={api.proyectos.config.presupuesto.uvt.select}
                value={uvt_id}
              />
            }
          />
          }

        <ParadigmaLabeledInput
          label="Cliente"
          labelColumns={4}
          fieldColumns={8}
          inputComponent={
            <Fragment>
             <ParadigmaAsyncSeeker
               fieldName="empresa_id"
               url={api.clientes.empresas.select}
               disabled={paradigmaModalProps.disabled}
               value={empresa_id}
               onChange={(e) => this.setState({ empresa_id: (e) ? (e.pk) : (null) })}
             />
             <FormFeedback className={(errors.empresa_id != undefined ? "d-block" : "")}> {errors.empresa_id} </FormFeedback>
            </Fragment>
          }
        />

        <ParadigmaLabeledInput
          label="Fecha De Facturación"
          fieldName=""
          labelColumns={4}
          fieldColumns={8}
          inputComponent={
            <DatePicker
                selected={fechaDeFacturacion}
                onChange={(e) => this.setState({ 'fechaDeFacturacion': e })}
                timeFormat=""
                className="form-control"
                timeIntervals={15}
                dateFormat="DD/MM/YYYY"
                disabled={paradigmaModalProps.disabled}
                timeCaption="time"
                customInput={<InputMask name="fechaDeFacturacion" className="form-control" mask="99/99/9999" type="text" />}
            />
          }
        />

        <ParadigmaLabeledInput
          label="Fecha De Cobro"
          fieldName="fechaDeCobro"
          labelColumns={4}
          fieldColumns={8}
          inputComponent={
            <DatePicker
              selected={fechaDeCobro}
              onChange={this.onFechaDeCobroChange}
              timeFormat=""
              className="form-control"
              disabled={paradigmaModalProps.disabled}
              timeIntervals={15}
              dateFormat="DD/MM/YYYY"
              timeCaption="time"
              customInput={<InputMask name="fechaDeCobro" className="form-control" mask="99/99/9999" type="text" />}
            />
          }
        />

        <ParadigmaLabeledInput
          type="number"
          label="Importe ($)"
          labelColumns={4}
          fieldColumns={8}
          inputComponent={
            <Fragment>
              <CurrencyInput
                placeholder='0'
                className='monto'
                selectOnFocus={true}
                maskOptions={{ includeThousandsSeparator: true, allowLeadingZeroes: true }}
                disabled={paradigmaModalProps.disabled}
                value={monto}
                onChange={this.onMontoChange}
                onBlur={() => this.setState({ monto: (monto != null && monto != '') ? (monto) : ('0') })}
              />
              <FormFeedback className={(errors.monto != undefined ? "d-block" : "")}>{errors.monto}</FormFeedback>
            </Fragment>
          }
        />

        <div className="ui-divider" />

        <ParadigmaLabeledInput
          type="number"
          label="Comisiones ($)"
          labelColumns={4}
          fieldColumns={8}
          inputComponent={
            <div className="ui-percent-money">
                <Input
                  disabled
                  value={porcentajeUVT + '%'}
                />
                <CurrencyInput
                  disabled
                  placeholder='0'
                  className='monto'
                  selectOnFocus
                  maskOptions={{ includeThousandsSeparator: true, allowLeadingZeroes: true }}
                  value={formatCurrency(montoUVT)}
                />
            </div>
          }
        />

        <ParadigmaLabeledInput
          label="Insumos Directos ($)"
          labelColumns={4}
          fieldColumns={8}
          inputComponent={
            <Fragment>
              <CurrencyInput
                className='monto'
                type='text'
                selectOnFocus
                disabled={paradigmaModalProps.disabled}
                maskOptions={{ includeThousandsSeparator: true, allowLeadingZeroes: true }}
                value={(insumosDirectos) ? (insumosDirectos) : '0,00'}
                onChange={d => this.setState({ insumosDirectos: d })}
              />
              <FormFeedback className={(errors.insumosDirectos ? "d-block" : "")}>{errors.insumosDirectos}</FormFeedback>
            </Fragment>
          }
        />

        <ParadigmaLabeledInput
          label="Importe a Distribuir ($)"
          labelColumns={4}
          fieldColumns={8}
          inputComponent={
            <CurrencyInput
              disabled
              placeholder='0'
              className='monto'
              selectOnFocus={true}
              maskOptions={{
                includeThousandsSeparator: true,
                allowLeadingZeroes: true,
                prefix: ((parseMontoFloat(monto) - montoUVT - parseMontoFloat(insumosDirectos)) < 0) ? ('-') : ('')
              }}
              value={formatCurrency(Math.abs((parseMontoFloat(monto) - montoUVT - parseMontoFloat(insumosDirectos))))}
            />
          }
        />

        <ParadigmaLabeledInput
          type="textarea"
          labelColumns={4}
          fieldColumns={8}
          rows={5}
          label="Observaciones"
          disabled={paradigmaModalProps.disabled}
          value={observaciones}
          onChange={(e) => this.setState({ observaciones: e.target.value })}
          fieldName="observaciones"
        />

        <ParadigmaLabeledInput
          label="Lider Técnico"
          labelColumns={4}
          fieldColumns={8}
          inputComponent={
            <Fragment>
             <ParadigmaAsyncSeeker2
               disabled={paradigmaModalProps.disabled}
               clearable={true}
               url={api.usuarios.personal.select}
               parameters={{
                   paginationEnabled: false,
                   sort: ['fullname']
               }}
               displayField="fullname"
               onChange={(e) => this.setState({personalDistribucion_id: (e) ? (e.id) : null })}
               value={this.state.personalDistribucion_id}
             />
             <FormFeedback className={(errors.personalDistribucion_id != undefined ? "d-block" : "")}> {errors.personalDistribucion_id} </FormFeedback>
            </Fragment>
          }
        />

        <div className="ui-divider" />

        <ParadigmaLabeledInput
          label={"Funcionamiento PLQ %"}
          labelColumns={4}
          fieldColumns={4}
          inputComponent={
            <Fragment>
              <Input
                type="number"
                onFocus={e => e.target.select()}
                value={porcentajeFPLQ}
                disabled={paradigmaModalProps.disabled}
                onChange={(e) =>
                  {
                    this.setState(
                      {porcentajeFPLQ:
                        (!e.target.value
                          ? 0
                          :(
                            parseFloat(e.target.value) > 100
                            ? (100)
                            : parseFloat(e.target.value)
                          )
                        )
                      }
                    );
                    this.setState(
                      {porcentajeEjecutores:
                        parseFloat(100 - e.target.value - porcentajes.reduce((pv, cv) => pv + cv.porcentaje, 0))
                      }
                    )
                  }
                }
              />
              <FormFeedback className={(errors.porcentajeFPLQ ? "d-block" : "")}>{errors.porcentajeFPLQ}</FormFeedback>
            </Fragment>
          }
        />
        <ParadigmaLabeledInput
          label={"Ejecutores %"}
          labelColumns={4}
          fieldColumns={4}
          inputComponent={
            <Fragment>
              <Input
                type="number"
                disabled
                onFocus={e => e.target.select()}
                value={porcentajeEjecutores}
                onChange={(e) => this.setState({ porcentajeEjecutores: (!e.target.value ? 0 : (parseFloat(e.target.value) > 100 ? (100) : parseFloat(e.target.value))) })} />
              <FormFeedback className={(errors.porcentajeEjecutores ? "d-block" : "")}>{errors.porcentajeEjecutores}</FormFeedback>
            </Fragment>
          }
        />
        <Row className="my-2">
          <Col xs={4}>
            <Label>Restantes %</Label>
          </Col>
          <Col xs={4}>
            <Input
              type="select"
              onChange={
                (evt) =>{
                  this.updatePorcentajesArray(evt.target.value);
                  if (evt.target.value == 0){
                    this.setState(
                      {porcentajeEjecutores:
                        parseFloat(100 - porcentajeFPLQ)
                      }
                    );
                  }
                }
              }
              value={porcentajes.length}
              disabled={paradigmaModalProps.disabled}
            >
              {
                [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((val, index) => (
                  <option value={val} key={`porcentajes-value-${index}`}>{val}</option>
                ))
              }
            </Input>
          </Col>
        </Row>
        {
          porcentajes.map((p, index) => (
            <Row className="mt-1">
              <Col xs={4}>
                <Input
                  onFocus={e => e.target.select()}
                  value={p.label}
                  maxLength={100}
                  disabled={paradigmaModalProps.disabled}
                  onChange={(e) =>
                    {
                      const idx = index;
                      const value = e.target.value ? e.target.value : "";
                      this.setState(prevState => {
                        const porcentajes = [...prevState.porcentajes];
                        porcentajes[idx].label = value;
                        return { ...prevState, porcentajes };
                      });
                    }
                  }
                />
                <FormFeedback className={(errors.labelAux ? "d-block" : "")}>{errors.labelAux}</FormFeedback>
              </Col>
              <Col xs={4}>
                <Input
                  type="number"
                  onFocus={e => e.target.select()}
                  value={p.porcentaje}
                  disabled={paradigmaModalProps.disabled}
                  onChange={(e) => {
                    const idx = index;
                    const value = (!e.target.value ? 0 : (parseFloat(e.target.value) > 100 ? (100) : parseFloat(e.target.value)));
                    this.setState(prevState => {
                      const porcentajes = [...prevState.porcentajes];
                      porcentajes[idx].porcentaje = value;
                      return { ...prevState, porcentajes };
                    },() => {
                      this.setState(
                        {porcentajeEjecutores:
                          parseFloat(100 - this.state.porcentajeFPLQ - this.state.porcentajes.reduce((pv, cv) => pv + cv.porcentaje, 0))
                        }
                      )
                    });
                  }
                  }
                />
              </Col>
            </Row>
          ))
        }
        {
          porcentajes.reduce((pv, cv) => pv + cv.porcentaje, (porcentajeFPLQ + porcentajeEjecutores)) > 100 &&
          <div className="row">
            <FormFeedback className="col-12 d-block">Los valores porcentuales suman más de 100%.</FormFeedback>
          </div>
        }
        </div>
      </ParadigmaModal >
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Imputaciones/Imputaciones/Modal.js